export const createEditOpportunitiesTranslations = {
  en: {
    // Modal Titles
    createOpportunity: "Create Opportunity",
    editOpportunity: "Edit Opportunity",

    // Section Headers
    financialInformation: "Financial Information",
    matchInformation: "Match Information",
    eventInformation: "Event Information",
    additionalInformation: "Additional Information",

    // Field Labels
    purse: "Purse",
    currency: "Currency",
    sports: "Sports",
    weightClass: "Weight Class",
    location: "Location",
    titleMatch: "Title Match",
    medicalSupportProvider: "Medical Support Provider",
    rounds: "Rounds",
    level: "Level",
    opportunityType: "Opportunity Type",
    eventDate: "Event Date",
    notes: "Notes",
    additionalDescription: "Additional Description",

    // Placeholder Text
    selectPurse: "Select Purse",
    selectCurrency: "Select Currency",
    selectSport: "Select Sport",
    selectWeightClass: "Select Weight Class",
    selectLocation: "Select Location",
    selectTitleMatch: "Select Title Match",
    selectMedicalSupport: "Select Medical Support",
    selectLevel: "Select Level",
    selectOpportunityType: "Select Opportunity Type",

    // Select Options
    noWeightClassesAvailable: "No weight classes available",
    noLocationsAvailable: "No locations available",
    noOptionsAvailable: "No options available",
    amateur: "Amateur",
    semiPro: "Semi Pro",
    professional: "Professional",
    fightBooking: "Fight Booking",
    shortNoticeReplacement: "Short Notice Replacement",
    tournamentRecruitment: "Tournament Recruitment",
    sparringPartnersNeeded: "Sparring Partners Needed",
    teamRecruitment: "Team Recruitment",
    guestCoachSearch: "Guest Coach Search",
    sponsorshipOpportunity: "Sponsorship Opportunity",
    mediaAppearance: "Media Appearance",
    contractSigning: "Contract Signing",

    // Button Text
    cancel: "Cancel",
    create: "Create",
    update: "Update",

    // Tooltip Content
    purseTooltipTitle: "Select the expected or offered purse range for the fight or opportunity.",
    purseTooltipDescription: "This helps filter realistic offers and set expectations early.",
    sportsTooltipTitle: "Select the combat sport this card is related to.",
    sportsTooltipDescription: "The type of fighter you're seeking.",
    weightClassTooltipTitle: "Select the weight division relevant to this card.",
    weightClassTooltipDescription: "The division you're recruiting for opportunities.",
    locationTooltipTitle: "Displays the main location where the fight or opportunity is expected to take place.",
    locationTooltipDescription: "Used for matchmaking, travel planning, and regional relevance.",
    titleMatchTooltipTitle: "Shows whether this fight or opportunity is for a title or championship belt.",
    titleMatchTooltipDescription: "Useful for highlighting high-stakes matchups.",
    medicalSupportTooltipTitle: "Indicates whether medical personnel or coverage will be provided at the event.",
    medicalSupportTooltipDescription: "Important for safety, regulations, and professional standards.",
    roundsTooltipTitle: "Indicates the number of rounds planned for the fight or opportunity.",
    roundsTooltipDescription: "Helps fighters and organizers understand the expected match length.",
    levelTooltipTitle: "Choose the competition level or ruleset that applies to this card.",
    levelTooltipDescription: "It helps match fighters and events by experience level and regulations.",
    eventDateTooltipTitle: "Displays the scheduled date of the fight or opportunity.",
    eventDateTooltipDescription: "Useful for planning, availability checks, and matchmaking timelines.",

    // Character Count
    characterCount: "1000 characters",

    // Validation Errors
    purseRequired: "Purse is required",
    currencyRequired: "Currency is required",
    sportRequired: "Sport is required",
    weightClassRequired: "Weight class is required",
    locationRequired: "Location is required",
    opportunityTypeRequired: "Opportunity type is required",
    eventDateRequired: "Event date is required",
    roundsMin: "Rounds must be at least 1",
    roundsMax: "Rounds cannot exceed 20",
    titleMatchRequired: "Title match selection is required",
    medicalSupportRequired: "Medical support selection is required",
    levelRequired: "Level is required",
    notesRequired: "Notes are required",
    additionalDescriptionRequired: "Additional description is required",
    validationErrorMessage: "Please fix the validation errors before submitting.",
    managerIdError: "Manager ID not found. Please log in again.",
    serverError: "Server error. Please try again later.",
    unauthorizedError: "Unauthorized. Please log in again.",
    networkError: "Network error. Please check your connection.",
    unexpectedError: "Unexpected error occurred.",
    successCreate: "Opportunity card created successfully.",
    successUpdate: "Opportunity card updated successfully.",
    next: "Next",
    previous: "Previous",
    loading: "Loading...",
    saving: "Saving...",
    creating: "Creating...",
    saveChanges: "Save Changes",
    templateIdRequired: "Template ID is required",
    createFailed: "Create failed: {{message}}",
    unknownError: "Unknown error",
    missingRequiredFieldsToast: "Please fill the required fields in {{step}}: {{fields}}.",
    andMoreFields: "and {{count}} more",
    enterField: "Enter {{field}}",
    selectField: "Select {{field}}",
    selectFieldWithEllipsis: "Select {{field}}...",
    maxAllowed: "Max allowed: {{max}}",
    finalAmount: "Final amount: {{amount}}",
    minimumPayoutMessage: "Minimum payout is 1.00. Increase percentage or base amount.",
    unsupportedFieldType: "Unsupported field type: {{type}}",
    uploadedFile: "Uploaded file",
    yes: "Yes",
    no: "No",
    reviewConfirm: "Review & Confirm",
    checkDetailsBeforeSaving: "Check all details before saving",
    checkDetailsBeforeCreating: "Check all details before creating",
    ready: "Ready",
    incompleteFields: "Incomplete fields",
    addItem: "Add {{item}}",
    clearAll: "Clear All",
    noItemsAddedYet: "No items added yet",
    remove: "Remove",
    clear: "Clear",
    editing: "Editing",
    stepOf: "Step {{current}} of {{total}}",
    progress: "Progress",
    repeatable: "Repeatable",
    noTemplateConfigured: "No template configured",
    requiredEnterField: "Please enter {{field}}",
    requiredSelectField: "Please select {{field}}",
    requiredUploadField: "Please upload {{field}}",
    requiredChooseField: "Please choose {{field}}",
    searchCountry: "Search country...",
    openCountryList: "Open country list",
    noCountriesFound: "No countries found",
    selectCountryFirst: "Select a country first",
    loadingCities: "Loading cities...",
    searchCity: "Search city...",
    openCityList: "Open city list",
    noCitiesFound: "No cities found",
    selectOptions: "Select options...",
    minutes: "minutes",
    seconds: "seconds",
    hours: "hours",
    searchFighterByName: "Search fighter by name...",
    clearSelection: "Clear selection",
    useManualValue: "Use \"{{value}}\"",
    noFightersFoundForSearch: "No fighters found for this search",
    searchOrTypeCustomFighter: "Search fighters or type a custom name",
    typeToSearchFighters: "Type to search fighters...",
    chooseFile: "Choose file",
    noFileChosen: "No file chosen",
    uploadingFile: "Uploading...",
    viewUploadedFile: "View uploaded file",
    removeFile: "Remove",
    fileSizeLimit: "File size must be {{size}}MB or less",
    unsupportedFileType: "Please upload a supported file type",
    fileUploadFailed: "File upload failed",
    pleaseFillThisField: "Please fill this field",
    completeRequiredFieldsOnStep: "Please complete required fields on this step before continuing.",
    completeAllRequiredFields: "Please complete all required fields.",
    payoutPolicy: {
      coreOutcomes: "Core outcomes",
      customOutcomes: "Custom outcomes",
      components: "Components",
      mode: "Mode",
      baseLocked: "Base locked",
      baseAmountIncluded: "Base amount included",
      notSelectable: "Not selectable",
      selectComponents: "Select components",
      addComponentsFirst: "Add components first",
      noPayoutPoliciesConfigured: "No payout policies configured.",
      selectionModes: {
        BASE_PLUS_SELECTED_COMPONENTS: "Base plus selected components",
        SELECTED_COMPONENTS_ONLY: "Selected components only",
      },
    },

    // Fight Template - Step Titles
    coreInformation: "Core Information",
    fightDetails: "Fight Details",
    bonusesExpensesPenalties: "Bonuses, Expenses & Penalties",
    payoutPoliciesStep: "Payout Policies",
    deadlineRules: "Deadline Rules",

    // Fight Template - Field Labels
    opponent: "Opponent",
    baseAmount: "Base Amount",
    paymentMode: "Payment Mode",
    dealNotes: "Deal Notes",
    sport: "Sport",
    ruleset: "Ruleset",
    country: "Country",
    city: "City",
    venue: "Venue",
    numberOfRounds: "Number of Rounds",
    roundDuration: "Round Duration",
    titleFight: "Title Fight",
    titleDescription: "Title Description",
    medicalSupportProvided: "Medical Support Provided",
    medicalDocument: "Medical Document",
    category: "Category",
    componentType: "Component Type",
    expenseDescription: "Expense Description",
    calculationMode: "Calculation Mode",
    value: "Value",
    fundingStage: "Funding Stage",

    // Fight Template - Placeholders
    searchOrTypeFighterName: "Search or type fighter name...",
    enterDealNotesPlaceholder: "Enter any special terms, agreements, or additional information...",
    describeTitlePlaceholder: "Describe the title, belt, or championship at stake...",
    uploadMedicalDocPlaceholder: "Upload medical documentation (PDF or Word only)...",
    expenseDescriptionExample: "Ex: Hotel stay",

    // Fight Template - Validation Messages
    roundDurationMaxMessage: "Round duration cannot exceed 60 minutes.",

    // Fight Template - Payment Mode Options
    upfront: "Upfront",
    split: "Split",

    // Fight Template - Category (kind) Options
    bonus: "Bonus",
    expense: "Expense",
    penalty: "Penalty",

    // Fight Template - Component Type Options
    winBonus: "Win Bonus",
    performanceBonus: "Performance Bonus",
    fightOfTheNight: "Fight of the Night",
    performanceOfTheNight: "Performance of the Night",
    knockoutOfTheNight: "Knockout of the Night",
    submissionOfTheNight: "Submission of the Night",
    onWeightBonus: "On-Weight Bonus",
    mediaPromoBonus: "Media & Promo Bonus",
    ticketSalesCommission: "Ticket Sales Commission",
    ppvShare: "PPV Share",
    lockerRoomBonus: "Locker Room Bonus",
    travelExpense: "Travel Expense",
    perDiemExpense: "Per Diem Expense",
    latePenalty: "Late Penalty",

    // Fight Template - Calculation Mode Options
    fixedAmount: "Fixed Amount",
    percentageOfBaseAmount: "Percentage of Base Amount",

    // Fight Template - Funding Stage Options
    preEvent: "Pre Event",
    postEvent: "Post Event",

    // Fight Template - Payout Outcomes
    win: "Win",
    draw: "Draw",
    loss: "Loss",
    noShowFault: "No-Show Fault",
    noShowMedical: "No-Show Medical",
    eventCancelled: "Event Cancelled",
    opponentNoShow: "Opponent No-Show",
  },
  de: {
    // Modal Titles
    createOpportunity: "Möglichkeit erstellen",
    editOpportunity: "Möglichkeit bearbeiten",

    // Section Headers
    financialInformation: "Finanzielle Informationen",
    matchInformation: "Spielinformationen",
    eventInformation: "Veranstaltungsinformationen",
    additionalInformation: "Zusätzliche Informationen",

    // Field Labels
    purse: "Börse",
    currency: "Währung",
    sports: "Sportarten",
    weightClass: "Gewichtsklasse",
    location: "Ort",
    titleMatch: "Titelkampf",
    medicalSupportProvider: "Medizinischer Support",
    rounds: "Runden",
    level: "Stufe",
    opportunityType: "Möglichkeitstyp",
    eventDate: "Veranstaltungsdatum",
    notes: "Notizen",
    additionalDescription: "Zusätzliche Beschreibung",

    // Placeholder Text
    selectPurse: "Börse auswählen",
    selectCurrency: "Währung auswählen",
    selectSport: "Sportart auswählen",
    selectWeightClass: "Gewichtsklasse auswählen",
    selectLocation: "Ort auswählen",
    selectTitleMatch: "Titelkampf auswählen",
    selectMedicalSupport: "Medizinischen Support auswählen",
    selectLevel: "Stufe auswählen",
    selectOpportunityType: "Möglichkeitstyp auswählen",

    // Select Options
    noWeightClassesAvailable: "Keine Gewichtsklassen verfügbar",
    noLocationsAvailable: "Keine Orte verfügbar",
    noOptionsAvailable: "Keine Optionen verfügbar",
    amateur: "Amateur",
    semiPro: "Halbprofi",
    professional: "Professionell",
    fightBooking: "Kampfbuchung",
    shortNoticeReplacement: "Kurzfristiger Ersatz",
    tournamentRecruitment: "Turnier-Rekrutierung",
    sparringPartnersNeeded: "Sparringspartner gesucht",
    teamRecruitment: "Teamanwerbung",
    guestCoachSearch: "Suche nach Gasttrainer",
    sponsorshipOpportunity: "Sponsoring-Möglichkeit",
    mediaAppearance: "Medienauftritt",
    contractSigning: "Vertragsunterzeichnung",

    // Button Text
    cancel: "Abbrechen",
    create: "Erstellen",
    update: "Aktualisieren",

    // Tooltip Content
    purseTooltipTitle: "Wählen Sie den erwarteten oder angebotenen Börsenbereich für den Kampf oder die Möglichkeit.",
    purseTooltipDescription: "Dies hilft, realistische Angebote zu filtern und Erwartungen frühzeitig zu setzen.",
    sportsTooltipTitle: "Wählen Sie die Kampfsportart aus, auf die sich diese Karte bezieht.",
    sportsTooltipDescription: "Die Art von Kämpfer, die Sie suchen.",
    weightClassTooltipTitle: "Wählen Sie die Gewichtsklasse aus, die für diese Karte relevant ist.",
    weightClassTooltipDescription: "Die Division, für die Sie Möglichkeiten rekrutieren.",
    locationTooltipTitle: "Zeigt den Hauptort an, an dem der Kampf oder die Möglichkeit stattfinden soll.",
    locationTooltipDescription: "Wird für Matchmaking, Reiseplanung und regionale Relevanz verwendet.",
    titleMatchTooltipTitle: "Zeigt an, ob es sich bei diesem Kampf oder dieser Möglichkeit um einen Titel oder eine Meisterschaft handelt.",
    titleMatchTooltipDescription: "Nützlich, um wichtige Kämpfe hervorzuheben.",
    medicalSupportTooltipTitle: "Gibt an, ob medizinisches Personal oder eine Abdeckung bei der Veranstaltung bereitgestellt wird.",
    medicalSupportTooltipDescription: "Wichtig für Sicherheit, Vorschriften und professionelle Standards.",
    roundsTooltipTitle: "Gibt die Anzahl der geplanten Runden für den Kampf oder die Möglichkeit an.",
    roundsTooltipDescription: "Hilft Kämpfern und Organisatoren, die erwartete Kampflänge zu verstehen.",
    levelTooltipTitle: "Wählen Sie die Wettkampfstufe oder das Regelwerk, das auf diese Karte anwendbar ist.",
    levelTooltipDescription: "Es hilft, Kämpfer und Veranstaltungen nach Erfahrungsstufe und Vorschriften abzustimmen.",
    eventDateTooltipTitle: "Zeigt das geplante Datum des Kampfes oder der Möglichkeit an.",
    eventDateTooltipDescription: "Nützlich für Planung, Verfügbarkeitsprüfungen und Zeitpläne für Matchmaking.",

    // Character Count
    characterCount: " 1000 Zeichen",

    // Validation Errors
    purseRequired: "Börse ist erforderlich",
    currencyRequired: "Währung ist erforderlich",
    sportRequired: "Sportart ist erforderlich",
    weightClassRequired: "Gewichtsklasse ist erforderlich",
    locationRequired: "Ort ist erforderlich",
    opportunityTypeRequired: "Möglichkeitstyp ist erforderlich",
    eventDateRequired: "Veranstaltungsdatum ist erforderlich",
    roundsMin: "Runden müssen mindestens 1 sein",
    roundsMax: "Runden dürfen 20 nicht überschreiten",
    titleMatchRequired: "Titelkampf-Auswahl ist erforderlich",
    medicalSupportRequired: "Medizinischer Support-Auswahl ist erforderlich",
    levelRequired: "Stufe ist erforderlich",
    notesRequired: "Notizen sind erforderlich",
    additionalDescriptionRequired: "Zusätzliche Beschreibung ist erforderlich",
    validationErrorMessage: "Bitte beheben Sie die Validierungsfehler vor dem Absenden.",
    managerIdError: "Manager-ID nicht gefunden. Bitte melden Sie sich erneut an.",
    serverError: "Serverfehler. Bitte versuchen Sie es später erneut.",
    unauthorizedError: "Nicht autorisiert. Bitte melden Sie sich erneut an.",
    networkError: "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
    unexpectedError: "Unerwarteter Fehler aufgetreten.",
    successCreate: "Möglichkeitskarte erfolgreich erstellt.",
    successUpdate: "Möglichkeitskarte erfolgreich aktualisiert.",
    next: "Weiter",
    previous: "Zurück",
    loading: "Laden...",
    saving: "Speichern...",
    creating: "Erstellen...",
    saveChanges: "Änderungen speichern",
    templateIdRequired: "Vorlagen-ID ist erforderlich",
    createFailed: "Erstellen fehlgeschlagen: {{message}}",
    unknownError: "Unbekannter Fehler",
    missingRequiredFieldsToast: "Bitte füllen Sie die Pflichtfelder in {{step}} aus: {{fields}}.",
    andMoreFields: "und {{count}} weitere",
    enterField: "{{field}} eingeben",
    selectField: "{{field}} auswählen",
    selectFieldWithEllipsis: "{{field}} auswählen...",
    maxAllowed: "Maximal erlaubt: {{max}}",
    finalAmount: "Endbetrag: {{amount}}",
    minimumPayoutMessage: "Die Mindestauszahlung beträgt 1,00. Erhöhen Sie den Prozentsatz oder den Basisbetrag.",
    unsupportedFieldType: "Nicht unterstützter Feldtyp: {{type}}",
    uploadedFile: "Hochgeladene Datei",
    yes: "Ja",
    no: "Nein",
    reviewConfirm: "Prüfen & Bestätigen",
    checkDetailsBeforeSaving: "Prüfen Sie alle Details vor dem Speichern",
    checkDetailsBeforeCreating: "Prüfen Sie alle Details vor dem Erstellen",
    ready: "Bereit",
    incompleteFields: "Unvollständige Felder",
    addItem: "{{item}} hinzufügen",
    clearAll: "Alles löschen",
    noItemsAddedYet: "Noch keine Einträge hinzugefügt",
    remove: "Entfernen",
    clear: "Leeren",
    editing: "Bearbeitung",
    stepOf: "Schritt {{current}} von {{total}}",
    progress: "Fortschritt",
    repeatable: "Wiederholbar",
    noTemplateConfigured: "Keine Vorlage konfiguriert",
    requiredEnterField: "Bitte {{field}} eingeben",
    requiredSelectField: "Bitte {{field}} auswählen",
    requiredUploadField: "Bitte {{field}} hochladen",
    requiredChooseField: "Bitte {{field}} auswählen",
    searchCountry: "Land suchen...",
    openCountryList: "Länderliste öffnen",
    noCountriesFound: "Keine Länder gefunden",
    selectCountryFirst: "Zuerst ein Land auswählen",
    loadingCities: "Städte werden geladen...",
    searchCity: "Stadt suchen...",
    openCityList: "Städteliste öffnen",
    noCitiesFound: "Keine Städte gefunden",
    selectOptions: "Optionen auswählen...",
    minutes: "Minuten",
    seconds: "Sekunden",
    hours: "Stunden",
    searchFighterByName: "Kämpfer nach Namen suchen...",
    clearSelection: "Auswahl löschen",
    useManualValue: "\"{{value}}\" verwenden",
    noFightersFoundForSearch: "Keine Kämpfer für diese Suche gefunden",
    searchOrTypeCustomFighter: "Kämpfer suchen oder eigenen Namen eingeben",
    typeToSearchFighters: "Tippen, um Kämpfer zu suchen...",
    chooseFile: "Datei auswählen",
    noFileChosen: "Keine Datei ausgewählt",
    uploadingFile: "Wird hochgeladen...",
    viewUploadedFile: "Hochgeladene Datei anzeigen",
    removeFile: "Entfernen",
    fileSizeLimit: "Die Datei darf höchstens {{size}} MB groß sein",
    unsupportedFileType: "Bitte laden Sie einen unterstützten Dateityp hoch",
    fileUploadFailed: "Dateiupload fehlgeschlagen",
    pleaseFillThisField: "Bitte füllen Sie dieses Feld aus",
    completeRequiredFieldsOnStep: "Bitte füllen Sie die Pflichtfelder in diesem Schritt aus, bevor Sie fortfahren.",
    completeAllRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus.",
    payoutPolicy: {
      coreOutcomes: "Kern-Ergebnisse",
      customOutcomes: "Benutzerdefinierte Ergebnisse",
      components: "Komponenten",
      mode: "Modus",
      baseLocked: "Basis gesperrt",
      baseAmountIncluded: "Basisbetrag enthalten",
      notSelectable: "Nicht auswählbar",
      selectComponents: "Komponenten auswählen",
      addComponentsFirst: "Zuerst Komponenten hinzufügen",
      noPayoutPoliciesConfigured: "Keine Auszahlungsrichtlinien konfiguriert.",
      selectionModes: {
        BASE_PLUS_SELECTED_COMPONENTS: "Basis plus ausgewählte Komponenten",
        SELECTED_COMPONENTS_ONLY: "Nur ausgewählte Komponenten",
      },
    },

    // Fight Template - Step Titles
    coreInformation: "Kerninformationen",
    fightDetails: "Kampfdetails",
    bonusesExpensesPenalties: "Boni, Ausgaben & Strafen",
    payoutPoliciesStep: "Auszahlungsrichtlinien",
    deadlineRules: "Fristregeln",

    // Fight Template - Field Labels
    opponent: "Gegner",
    baseAmount: "Grundbetrag",
    paymentMode: "Zahlungsart",
    dealNotes: "Deal-Notizen",
    sport: "Sportart",
    ruleset: "Regelwerk",
    country: "Land",
    city: "Stadt",
    venue: "Veranstaltungsort",
    numberOfRounds: "Anzahl der Runden",
    roundDuration: "Rundendauer",
    titleFight: "Titelkampf",
    titleDescription: "Titelbeschreibung",
    medicalSupportProvided: "Medizinische Unterstützung vorhanden",
    medicalDocument: "Medizinisches Dokument",
    category: "Kategorie",
    componentType: "Komponententyp",
    expenseDescription: "Ausgabenbeschreibung",
    calculationMode: "Berechnungsmodus",
    value: "Wert",
    fundingStage: "Finanzierungsphase",

    // Fight Template - Placeholders
    searchOrTypeFighterName: "Kämpfername suchen oder eingeben...",
    enterDealNotesPlaceholder: "Geben Sie besondere Bedingungen, Vereinbarungen oder zusätzliche Informationen ein...",
    describeTitlePlaceholder: "Beschreiben Sie den Titel, Gürtel oder die Meisterschaft, um die es geht...",
    uploadMedicalDocPlaceholder: "Medizinische Unterlagen hochladen (nur PDF oder Word)...",
    expenseDescriptionExample: "Z. B.: Hotelaufenthalt",

    // Fight Template - Validation Messages
    roundDurationMaxMessage: "Die Rundendauer darf 60 Minuten nicht überschreiten.",

    // Fight Template - Payment Mode Options
    upfront: "Vorab",
    split: "Aufgeteilt",

    // Fight Template - Category (kind) Options
    bonus: "Bonus",
    expense: "Ausgabe",
    penalty: "Strafe",

    // Fight Template - Component Type Options
    winBonus: "Sieg-Bonus",
    performanceBonus: "Leistungsbonus",
    fightOfTheNight: "Kampf der Nacht",
    performanceOfTheNight: "Leistung der Nacht",
    knockoutOfTheNight: "Knockout der Nacht",
    submissionOfTheNight: "Submission der Nacht",
    onWeightBonus: "Gewichtslimit-Bonus",
    mediaPromoBonus: "Medien- & Promo-Bonus",
    ticketSalesCommission: "Ticketverkaufsprovision",
    ppvShare: "PPV-Anteil",
    lockerRoomBonus: "Umkleidekabinen-Bonus",
    travelExpense: "Reisekosten",
    perDiemExpense: "Tagegeld",
    latePenalty: "Verspätungsstrafe",

    // Fight Template - Calculation Mode Options
    fixedAmount: "Fester Betrag",
    percentageOfBaseAmount: "Prozentsatz des Grundbetrags",

    // Fight Template - Funding Stage Options
    preEvent: "Vor der Veranstaltung",
    postEvent: "Nach der Veranstaltung",

    // Fight Template - Payout Outcomes
    win: "Sieg",
    draw: "Unentschieden",
    loss: "Niederlage",
    noShowFault: "Nichterscheinen (verschuldet)",
    noShowMedical: "Nichterscheinen (medizinisch)",
    eventCancelled: "Veranstaltung abgesagt",
    opponentNoShow: "Gegner nicht erschienen",
  },
  hr: {
    // Modal Titles
    createOpportunity: "Kreiraj priliku",
    editOpportunity: "Uredi priliku",

    // Section Headers
    financialInformation: "Financijske informacije",
    matchInformation: "Informacije o borbi",
    eventInformation: "Informacije o događaju",
    additionalInformation: "Dodatne informacije",

    // Field Labels
    purse: "Nagrada",
    currency: "Valuta",
    sports: "Sportovi",
    weightClass: "Težinska kategorija",
    location: "Lokacija",
    titleMatch: "Naslovna borba",
    medicalSupportProvider: "Pružatelj medicinske podrške",
    rounds: "Runde",
    level: "Razina",
    opportunityType: "Vrsta prilike",
    eventDate: "Datum događaja",
    notes: "Bilješke",
    additionalDescription: "Dodatni opis",

    // Placeholder Text
    selectPurse: "Odaberi nagradu",
    selectCurrency: "Odaberi valutu",
    selectSport: "Odaberi sport",
    selectWeightClass: "Odaberi težinsku kategoriju",
    selectLocation: "Odaberi lokaciju",
    selectTitleMatch: "Odaberi naslovnu borbu",
    selectMedicalSupport: "Odaberi medicinsku podršku",
    selectLevel: "Odaberi razinu",
    selectOpportunityType: "Odaberi vrstu prilike",

    // Select Options
    noWeightClassesAvailable: "Nema dostupnih težinskih kategorija",
    noLocationsAvailable: "Nema dostupnih lokacija",
    noOptionsAvailable: "Nema dostupnih opcija",
    amateur: "Amater",
    semiPro: "Poluprofesionalac",
    professional: "Profesionalac",
    fightBooking: "Rezervacija borbe",
    shortNoticeReplacement: "Zamjena u posljednji tren",
    tournamentRecruitment: "Regrutacija za turnir",
    sparringPartnersNeeded: "Potrebni sparing partneri",
    teamRecruitment: "Regrutacija tima",
    guestCoachSearch: "Potražnja gostujućeg trenera",
    sponsorshipOpportunity: "Mogućnost sponzorstva",
    mediaAppearance: "Medijski nastup",
    contractSigning: "Potpisivanje ugovora",

    // Button Text
    cancel: "Odustani",
    create: "Kreiraj",
    update: "Ažuriraj",

    // Tooltip Content
    purseTooltipTitle: "Odaberite očekivani ili ponuđeni raspon nagrade za borbu ili priliku.",
    purseTooltipDescription: "Ovo pomaže filtrirati realistične ponude i rano postaviti očekivanja.",
    sportsTooltipTitle: "Odaberite borilački sport na koji se ova kartica odnosi.",
    sportsTooltipDescription: "Vrsta boraca koju tražite.",
    weightClassTooltipTitle: "Odaberite težinsku kategoriju relevantnu za ovu karticu.",
    weightClassTooltipDescription: "Kategorija za koju regrutirate prilike.",
    locationTooltipTitle: "Prikazuje glavnu lokaciju gdje se očekuje da će se borba ili prilika održati.",
    locationTooltipDescription: "Koristi se za povezivanje, planiranje putovanja i regionalnu relevantnost.",
    titleMatchTooltipTitle: "Pokazuje je li ova borba ili prilika za naslov ili prvenstveni pojas.",
    titleMatchTooltipDescription: "Koristno za isticanje borbi visokog uloga.",
    medicalSupportTooltipTitle: "Pokazuje hoće li medicinsko osoblje ili pokriće biti osigurano na događaju.",
    medicalSupportTooltipDescription: "Važno za sigurnost, propise i profesionalne standarde.",
    roundsTooltipTitle: "Označava broj planiranih rundi za borbu ili priliku.",
    roundsTooltipDescription: "Pomaže borcima i organizatorima razumjeti očekivanu duljinu borbe.",
    levelTooltipTitle: "Odaberite razinu natjecanja ili pravila koja se primjenjuju na ovu karticu.",
    levelTooltipDescription: "Pomaže uskladiti borce i događaje prema razini iskustva i propisima.",
    eventDateTooltipTitle: "Prikazuje planirani datum borbe ili prilike.",
    eventDateTooltipDescription: "Koristno za planiranje, provjeru dostupnosti i vremenske okvire za povezivanje.",

    // Character Count
    characterCount: "1000 znakova",

    // Validation Errors
    purseRequired: "Nagrada je obavezna",
    currencyRequired: "Valuta je obavezna",
    sportRequired: "Sport je obavezan",
    weightClassRequired: "Težinska kategorija je obavezna",
    locationRequired: "Lokacija je obavezna",
    opportunityTypeRequired: "Vrsta prilike je obavezna",
    eventDateRequired: "Datum događaja je obavezan",
    roundsMin: "Runde moraju biti najmanje 1",
    roundsMax: "Runde ne smiju premašiti 20",
    titleMatchRequired: "Odabir naslovne borbe je obavezan",
    medicalSupportRequired: "Odabir medicinske podrške je obavezan",
    levelRequired: "Razina je obavezna",
    notesRequired: "Bilješke su obavezne",
    additionalDescriptionRequired: "Dodatni opis je obavezan",
    validationErrorMessage: "Molimo ispravite greške u validaciji prije slanja.",
    managerIdError: "ID menadžera nije pronađen. Molimo prijavite se ponovno.",
    serverError: "Greška na poslužitelju. Molimo pokušajte ponovno kasnije.",
    unauthorizedError: "Neovlašteno. Molimo prijavite se ponovno.",
    networkError: "Mrežna greška. Molimo provjerite vašu povezanost.",
    unexpectedError: "Došlo je do neočekivane greške.",
    successCreate: "Kartica prilike uspješno kreirana.",
    successUpdate: "Kartica prilike uspješno ažurirana.",
    next: "Dalje",
    previous: "Natrag",
    loading: "Učitavanje...",
    saving: "Spremanje...",
    creating: "Stvaranje...",
    saveChanges: "Spremi promjene",
    templateIdRequired: "ID predloška je obavezan",
    createFailed: "Stvaranje nije uspjelo: {{message}}",
    unknownError: "Nepoznata greška",
    missingRequiredFieldsToast: "Molimo ispunite obavezna polja u {{step}}: {{fields}}.",
    andMoreFields: "i još {{count}}",
    enterField: "Unesite {{field}}",
    selectField: "Odaberite {{field}}",
    selectFieldWithEllipsis: "Odaberite {{field}}...",
    maxAllowed: "Maksimalno dopušteno: {{max}}",
    finalAmount: "Konačni iznos: {{amount}}",
    minimumPayoutMessage: "Minimalna isplata je 1,00. Povećajte postotak ili osnovni iznos.",
    unsupportedFieldType: "Nepodržana vrsta polja: {{type}}",
    uploadedFile: "Učitana datoteka",
    yes: "Da",
    no: "Ne",
    reviewConfirm: "Pregled i potvrda",
    checkDetailsBeforeSaving: "Provjerite sve detalje prije spremanja",
    checkDetailsBeforeCreating: "Provjerite sve detalje prije stvaranja",
    ready: "Spremno",
    incompleteFields: "Nepotpuna polja",
    addItem: "Dodaj {{item}}",
    clearAll: "Očisti sve",
    noItemsAddedYet: "Još nema dodanih stavki",
    remove: "Ukloni",
    clear: "Očisti",
    editing: "Uređivanje",
    stepOf: "Korak {{current}} od {{total}}",
    progress: "Napredak",
    repeatable: "Ponovljivo",
    noTemplateConfigured: "Nijedan predložak nije konfiguriran",
    requiredEnterField: "Unesite {{field}}",
    requiredSelectField: "Odaberite {{field}}",
    requiredUploadField: "Prenesite {{field}}",
    requiredChooseField: "Odaberite {{field}}",
    searchCountry: "Pretraži državu...",
    openCountryList: "Otvori popis država",
    noCountriesFound: "Nema pronađenih država",
    selectCountryFirst: "Najprije odaberite državu",
    loadingCities: "Učitavanje gradova...",
    searchCity: "Pretraži grad...",
    openCityList: "Otvori popis gradova",
    noCitiesFound: "Nema pronađenih gradova",
    selectOptions: "Odaberite opcije...",
    minutes: "minute",
    seconds: "sekunde",
    hours: "sati",
    searchFighterByName: "Pretraži borca po imenu...",
    clearSelection: "Očisti odabir",
    useManualValue: "Koristi \"{{value}}\"",
    noFightersFoundForSearch: "Nema boraca za ovu pretragu",
    searchOrTypeCustomFighter: "Pretražite borce ili unesite prilagođeno ime",
    typeToSearchFighters: "Upišite za pretragu boraca...",
    chooseFile: "Odaberi datoteku",
    noFileChosen: "Nijedna datoteka nije odabrana",
    uploadingFile: "Učitavanje...",
    viewUploadedFile: "Prikaži učitanu datoteku",
    removeFile: "Ukloni",
    fileSizeLimit: "Veličina datoteke mora biti {{size}} MB ili manje",
    unsupportedFileType: "Prenesite podržanu vrstu datoteke",
    fileUploadFailed: "Učitavanje datoteke nije uspjelo",
    pleaseFillThisField: "Molimo ispunite ovo polje",
    completeRequiredFieldsOnStep: "Molimo ispunite obavezna polja u ovom koraku prije nastavka.",
    completeAllRequiredFields: "Molimo ispunite sva obavezna polja.",
    payoutPolicy: {
      coreOutcomes: "Osnovni ishodi",
      customOutcomes: "Prilagođeni ishodi",
      components: "Komponente",
      mode: "Način",
      baseLocked: "Osnovica zaključana",
      baseAmountIncluded: "Osnovni iznos uključen",
      notSelectable: "Nije moguće odabrati",
      selectComponents: "Odaberite komponente",
      addComponentsFirst: "Najprije dodajte komponente",
      noPayoutPoliciesConfigured: "Politike isplate nisu konfigurirane.",
      selectionModes: {
        BASE_PLUS_SELECTED_COMPONENTS: "Osnovica + odabrane komponente",
        SELECTED_COMPONENTS_ONLY: "Samo odabrane komponente",
      },
    },

    // Fight Template - Step Titles
    coreInformation: "Osnovne informacije",
    fightDetails: "Detalji borbe",
    bonusesExpensesPenalties: "Bonusi, troškovi i kazne",
    payoutPoliciesStep: "Politike isplate",
    deadlineRules: "Pravila rokova",

    // Fight Template - Field Labels
    opponent: "Protivnik",
    baseAmount: "Osnovni iznos",
    paymentMode: "Način plaćanja",
    dealNotes: "Napomene o dogovoru",
    sport: "Sport",
    ruleset: "Pravilnik",
    country: "Država",
    city: "Grad",
    venue: "Mjesto održavanja",
    numberOfRounds: "Broj rundi",
    roundDuration: "Trajanje runde",
    titleFight: "Naslovna borba",
    titleDescription: "Opis naslova",
    medicalSupportProvided: "Osigurana medicinska podrška",
    medicalDocument: "Medicinski dokument",
    category: "Kategorija",
    componentType: "Vrsta komponente",
    expenseDescription: "Opis troška",
    calculationMode: "Način izračuna",
    value: "Vrijednost",
    fundingStage: "Faza financiranja",

    // Fight Template - Placeholders
    searchOrTypeFighterName: "Pretražite ili upišite ime borca...",
    enterDealNotesPlaceholder: "Unesite posebne uvjete, dogovore ili dodatne informacije...",
    describeTitlePlaceholder: "Opišite naslov, pojas ili prvenstvo o kojem je riječ...",
    uploadMedicalDocPlaceholder: "Prenesite medicinsku dokumentaciju (samo PDF ili Word)...",
    expenseDescriptionExample: "Npr.: Boravak u hotelu",

    // Fight Template - Validation Messages
    roundDurationMaxMessage: "Trajanje runde ne smije premašiti 60 minuta.",

    // Fight Template - Payment Mode Options
    upfront: "Unaprijed",
    split: "Podijeljeno",

    // Fight Template - Category (kind) Options
    bonus: "Bonus",
    expense: "Trošak",
    penalty: "Kazna",

    // Fight Template - Component Type Options
    winBonus: "Bonus za pobjedu",
    performanceBonus: "Bonus za nastup",
    fightOfTheNight: "Borba večeri",
    performanceOfTheNight: "Nastup večeri",
    knockoutOfTheNight: "Nokaut večeri",
    submissionOfTheNight: "Submisija večeri",
    onWeightBonus: "Bonus za urednu težinu",
    mediaPromoBonus: "Bonus za medije i promociju",
    ticketSalesCommission: "Provizija od prodaje ulaznica",
    ppvShare: "PPV udio",
    lockerRoomBonus: "Bonus za svlačionicu",
    travelExpense: "Putni trošak",
    perDiemExpense: "Dnevnica",
    latePenalty: "Kazna za kašnjenje",

    // Fight Template - Calculation Mode Options
    fixedAmount: "Fiksni iznos",
    percentageOfBaseAmount: "Postotak osnovnog iznosa",

    // Fight Template - Funding Stage Options
    preEvent: "Prije događaja",
    postEvent: "Nakon događaja",

    // Fight Template - Payout Outcomes
    win: "Pobjeda",
    draw: "Neriješeno",
    loss: "Poraz",
    noShowFault: "Nedolazak (krivnja borca)",
    noShowMedical: "Nedolazak (medicinski razlog)",
    eventCancelled: "Događaj otkazan",
    opponentNoShow: "Protivnik se nije pojavio",
  },
};